import { useState } from 'react';
import { lclClient } from '../api/lclClient';

export function useRibCorrection() {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function correct(accountId, { iban, bic }) {
    setSaving(true); setError(null);
    try {
      return await lclClient.correctRib(accountId, { iban, bic });
    } catch (e) {
      setError(e.response?.data?.message || e.message);
      throw e;
    } finally {
      setSaving(false);
    }
  }
  return { correct, saving, error };
}
